import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomContainer from "views/Container/CustomContainer";

const Schedule = () => {
  const { t, ready } = useTranslation(); // Hook to access translations
  const [selectedDate, setSelectedDate] = useState("");
  if (!ready) {
    return ``;
  }
  const data = t("event:events", { returnObjects: true });

  const availableDates = [...new Set(data?.map((event) => event.date))]; // Extract unique dates

  const filteredData = selectedDate
    ? data?.filter((event) => event.date === selectedDate)
    : data;

  return (
    <CustomContainer container={true}>
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Programme
        </Typography>
        {/* <Typography variant="h4" color="secondary" component="h1" gutterBottom>
          A venir très bientôt !
        </Typography> */}

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            marginBottom: 3,
          }}
        >
          {availableDates.map((date) => (
            <Button
              key={date}
              variant={selectedDate === date ? "contained" : "outlined"}
              onClick={() => setSelectedDate(date)}
            >
              {date}
            </Button>
          ))}
          <Button
            variant={selectedDate === "" ? "contained" : "outlined"}
            onClick={() => setSelectedDate("")}
          >
            {t("common:all")}
          </Button>
        </Box>

        <Grid container spacing={3}>
          {filteredData.map((event, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card elevation={3}>
                <CardContent>
                  <Typography variant="h6" component="h2">
                    {event.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    <strong>{t("common:level")}:</strong> {event.level}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {event.description}
                  </Typography>
                  <Stack spacing={1} mt={2}>
                    <Typography variant="body2">
                      <strong>{t("common:teacher")}:</strong>{" "}
                      {event.teachers.join(", ")}
                    </Typography>
                    <Typography variant="body2">
                      <strong>{t("common:time")}:</strong> {event.from} -{" "}
                      {event.to}
                    </Typography>
                    <Typography variant="body2">
                      <strong>{t("common:date")}:</strong> {event.date}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </CustomContainer>
  );
};

export default Schedule;
